import { render, staticRenderFns } from "./yunphonedialog.vue?vue&type=template&id=327a5f7c&scoped=true"
import script from "./yunphonedialog.vue?vue&type=script&lang=js"
export * from "./yunphonedialog.vue?vue&type=script&lang=js"
import style0 from "./yunphonedialog.vue?vue&type=style&index=0&id=327a5f7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327a5f7c",
  null
  
)

export default component.exports